/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import {
  Breakpoint,
  MediaQueryService
} from 'app/services/media-query.service';
import { MobileScrollService } from 'app/services/mobile-scroll.service';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  HeaderHeightProvider,
  HEIGHT_PROVIDER
} from '../../directives/details-page-header.directive';

declare let jQuery: any;

@Component({
  selector: 'app-insights-header',
  templateUrl: './insights-header.component.html',
  styleUrls: [
    './insights-header.component.scss',
    './insights-header-responsive.component.scss'
  ],
  providers: [
    { provide: HEIGHT_PROVIDER, useExisting: InsightsHeaderComponent }
  ]
})
export class InsightsHeaderComponent
  implements HeaderHeightProvider, OnInit, OnDestroy, AfterViewInit
{
  @Input() isFollowing: boolean;
  @Input() processingFollow: boolean;
  @Input() data: any;
  @Input() appInfo: string;
  @Input() showAppTitle: boolean;

  @Input() mobileFilterBreakpointReached: boolean;
  @Input() followBreakpointReached: boolean;

  @Output() mobileNavOpenClick: EventEmitter<Event> = new EventEmitter();

  @Output() followButtonClick: EventEmitter<Event> = new EventEmitter();

  @Output() showFilter: EventEmitter<Event> = new EventEmitter();

  @Output() applyFilter: EventEmitter<Event> = new EventEmitter();

  @Output() resetFilter: EventEmitter<Event> = new EventEmitter();

  tablet$: Observable<boolean>;
  desktop$: Observable<boolean>;
  truncate$: Observable<boolean>;
  sticky$: Observable<boolean>;
  showFilters = false;
  showFilterOptions = false;
  destroyToken: Subject<void>;
  showInfo = true;

  @ViewChild('titlebar') titlebar: ElementRef<HTMLElement>;
  @ViewChild('filters') filters: ElementRef<HTMLElement>;

  public get headerHeight() {
    return this.titlebar.nativeElement.getBoundingClientRect().height;
  }

  constructor(
    private mediaQueryService: MediaQueryService,
    private mobileScrollService: MobileScrollService
  ) {}

  ngOnInit(): void {
    this.destroyToken = new Subject();

    this.tablet$ = this.mediaQueryService.lt(Breakpoint.lg);
    this.desktop$ = this.mediaQueryService.gte(Breakpoint.lg);
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.truncate$ = this.mediaQueryService.activeBreakpoint$.pipe(
        map(
          bp =>
            bp < Breakpoint.md || (bp > Breakpoint.md && bp <= Breakpoint.lg)
        )
      );
    });

    this.mobileScrollService.isFilterOptionsOpen$.subscribe(value => {
      if (value) {
        jQuery('.filter-container').scrollTop(0);
      }
      this.showFilterOptions = value;
    });
  }

  ngOnDestroy() {
    this.destroyToken.next();
    this.destroyToken.complete();
  }

  onShowFilterClick() {
    this.setFilterValue(!this.showFilters);
    this.showFilter.emit();
  }

  onCloseFilterClick() {
    this.setFilterValue(false);
    this.resetFilter.emit();
  }

  onShowResultClick() {
    this.setFilterValue(false);
    this.applyFilter.emit();
  }

  handleFilterClick(evt) {
    if (!this.filters) return;
    if (!this.showFilters) return;

    const el = this.filters.nativeElement;
    const rect = el.getBoundingClientRect();

    if (evt.clientY > rect.bottom) {
      this.setFilterValue(false);
      return;
    }

    evt.preventDefault();
  }

  setFilterValue(value: boolean) {
    this.showFilters = value;
    this.mobileScrollService.toggleFilter(value);
  }

  @HostListener('window: scroll', ['$event'])
  handleScroll() {
    const bounds = this.titlebar.nativeElement.getBoundingClientRect();
    this.showInfo = bounds.top > 20;
  }
}
